export default __webpack_public_path__ + "static/media/Topik-1.083c9ef6.jpg";